/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_StartingInputs */



/**
* | output |
* | --- |
* | "Starting spell check process... please wait." |
*
* @param {Spellcheck_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_starting = /** @type {((inputs?: Spellcheck_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de la verification orthographique... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtschreibprüfung wird gestartet... Bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del controllo ortografico... attendere.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск процесса проверки орфографии... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando el proceso de revisión ortográfica... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在启动拼写检查……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェックプロセスを開始しています...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी जांच प्रक्रिया शुरू हो रही है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o processo de verificação ortográfica... aguarde.")
	return /** @type {LocalizedString} */ ("Starting spell check process... please wait.")
});